<style scpoed>

.top-margin {
  margin-left: 5px
}

</style>

<template>
  <el-row>
    <table-template  ref="list-template" :queryParams="searchInfo" actionUrl="question/findQuestionsForAdmin.action" >
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-select @change="$refs['list-template'].search()"   clearable placeholder="置顶状态" style="margin-left:5px;"
                          v-model="searchInfo.pushTopTimeType">
                <el-option :value="1" label="置顶中"></el-option>
                <el-option :value="2" label="未置顶"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select clearable placeholder="删除状态" style="margin-left:5px;"
                          v-model="searchInfo.del"  @change="$refs['list-template'].search()">
                <el-option :value="0" label="未删除"></el-option>
                <el-option :value="1" label="已删除"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-date-picker  @change="$refs['list-template'].loadList()" v-model="startEndTime" end-placeholder="发布结束时间" placeholder="按发布时间筛选"
                              start-placeholder="发布开始时间" type="datetimerange"
                             >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchInfo.keyword" style="width: 180px" placeholder="昵称/账号/帖子关键词" type="primary"></el-input>
              <el-button @click="search()" type="primary" >搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
                label="昵称/账号"
                prop="phone">
            <template scope="scope">
              {{scope.row.nickName}}<br/>{{scope.row.phone}}
            </template>
        </el-table-column>

        <el-table-column
                label="内容"
                prop="content">
          <template scope="scope">
            <span style="color:#4c79b3;" v-if="scope.row.carCategoryText">#{{scope.row.carCategoryText}}</span> &nbsp;{{scope.row.title}} <br/>{{scope.row.content}}
          </template>
        </el-table-column>

        <el-table-column
                label="渠道来源"
                prop="channels" width="140px">
          <template scope="scope">
            <p>
                 <span v-for="(item, index) in scope.row.channels" v-bind:key="index">
                              <template v-if="index<3">
                                    {{ item.channelName }}
                              </template>
                          </span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
                label="发布时间"
                prop="createTime">
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>

        <el-table-column
                  label="删除状态"
                prop="del" width="80px">
          <template scope="scope">
             <p v-if="scope.row.del == 0">未删除</p>
            <p v-else style="color:red;">已删除</p>

          </template>
        </el-table-column>
        <el-table-column
                label="置顶结束时间"
                prop="pushTopTime" width="225px">
          <template scope="scope" >
              <span v-if="scope.row.pushTopTime">{{scope.row.pushTopTime|dateTimeFormat}}</span><span v-if="scope.row.top ">（置顶中）</span>
          </template>
        </el-table-column>

        <el-table-column
                label="浏览量/回复数"
                prop="pushTopTime">
          <template scope="scope">
            <p> {{ scope.row.browseCount }} 浏览 | {{ scope.row.replyCount }} 个回帖 </p>
          </template>
        </el-table-column>

        <el-table-column
                label="操作">
          <template scope="scope">
            <el-button :disabled="scope.row.del=='1'" type="text" @click="deleteQuestion(scope.row.id)">
              {{ scope.row.del == 1 ? '已删除' : '删除' }}
            </el-button>
            <span style="margin-left:5px;margin-right:5px;color:#eee;">|</span>
            <el-button type="text" @click="show(scope.row.id)">查看详情</el-button>
            <span style="margin-left:5px;margin-left:5px;color:#eee;">|</span>
            <el-button type="text" @click="openTopeWindow(scope.row)">置顶</el-button>

          </template>
        </el-table-column>

      </template>
    </table-template>
    <el-dialog :visible.sync="dialogFormVisible" title="置顶" :destroy-on-close="true">
      <el-form :model="questionForm">
        <el-form-item label="置顶结束时间">
          <el-date-picker
                  v-model="questionForm.endDateTime"
                  placeholder="选择日期时间"
                  type="datetime"
                  :default-time="nowTimeStr"
                  @focus="setDefaultTime()"
                  value-format="timestamp">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="pushTop">确 定</el-button>
      </div>
    </el-dialog>

  </el-row>
</template>

<script>
import channelSelect from '@/components/channelSelect'
import QuestionModel from '../../framework/models/questionModel'
import Config from '../../framework/configs/Config'
import BasicPager from '../../mixins/BasicPager'
import TableTemplate from '@/components/TableTemplate'

export default {
  name: 'question-management',
  extends: BasicPager,
  data: function () {
    return {
      dialogFormVisible: false,
      nowTimeStr: null,
      questionForm: {
        id: null,
        endDateTime: null
      },
      baseImageUrl: Config.imageUrl,
      startEndTime: null,
      searchInfo: {
        keyword: null,
        startTime: null,
        endTime: null,
        channelId: null,
        sourceType: 1,
        del: null,
        pushTopTimeType: null
      }
    }
  },
  components: {
    TableTemplate,
    channelSelect
  },
  watch: {
    startEndTime: function (newValue) {
      if (newValue && newValue[0] && newValue[1]) {
        this.searchInfo.startTime = newValue[0].getTime()
        this.searchInfo.endTime = newValue[1].getTime()
      } else {
        this.searchInfo.startTime = null
        this.searchInfo.endTime = null
      }
    }
  },
  created: function () {
    let loginInfo = this.getLoginInfo()
    if (loginInfo.loginPath == 'channel') {
      this.searchInfo.channelId = loginInfo.id
    }
  },
  methods: {
    setDefaultTime: function () {
      this.nowTimeStr = new Date().toLocaleTimeString()
    },
    search: function () {
      this.$refs['list-template'].loadList()
    },
    deleteQuestion: function (questionId) {
      this.$confirm('此操作将删除该帖子, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          questionId: questionId
        }
        let listener = {
          success: function (dataInfo) {
            _this.$message({
              type: 'success',
              message: '删除成功!'
            })
            _this.$refs['list-template'].loadList()
          }
        }
        QuestionModel.deleteQuestion(_this, params, listener)
      })
    },
    show: function (questionId) {
      this.$router.push({
        name: '帖子详情',
        params: {
          questionId: questionId
        }
      })
    },
    channelChange: function (channelId) {
      this.searchInfo.channelId = channelId
      this.$refs['list-template'].loadList()
    },
    openTopeWindow (data) {
      this.dialogFormVisible = true
      this.questionForm.id = data.id
      if (data.pushTopTime) {
        this.questionForm.endDateTime = data.pushTopTime
      } else {
        this.questionForm.endDateTime = null
      }
    },
    pushTop: function () {
      let _this = this

      let param = {
        questionId: _this.questionForm.id
      }
      if (!this.questionForm.endDateTime) {
        param.endTime = 0
      } else {
        param.endTime = this.questionForm.endDateTime
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message({
            type: 'success',
            message: '置顶成功!'
          })
          _this.dialogFormVisible = false
          _this.nowTimeStr = null
          _this.$refs['list-template'].loadList()
        }

      }
      QuestionModel.pushQuestion(_this, param, listener)
    }

  }
}

</script>
